import React, { useEffect, useState } from "react"

const Pagination = ({ currentPage, hasPreviousPage, hasNextPage, lastPage, setCurrentPage, makeQueryPagination, whoIsCalling }) => {
    const [search, setSearch] = useState(false)

    useEffect(() => {
        if(search){
            if(whoIsCalling === 'blogs'){
                let tag = null
                if(window.location.pathname.includes('tags')){
                    tag = window.location.pathname.split('/')[3]
                }
                makeQueryPagination(currentPage,tag)
                window.scrollTo(0, 0); 
            }
            else if(whoIsCalling === 'reviews'){
                makeQueryPagination(currentPage)
                // window.scrollTo(0, 0); 
            }
        }
    }, [currentPage])

    let paginate = []

    let delta = 1,
    left = currentPage - delta,
    right = parseFloat(currentPage) + parseFloat(delta + 1),
    range = [],
    l;
        
    for (let i = 1; i <= lastPage; i++) {
        if (i == 1 || i == lastPage || i >= left && i <= right) {
            range.push(i);
        }
    }
    for (let i of range) {
        if (l) {
            if (i - l === 2 && lastPage - 1 !== l + 1 && l + 1 !== 2) {
                paginate.push(l + 1);
            } else if (i - l !== 1 && lastPage - currentPage !== 2) {
                paginate.push('...');
            }
        }
        paginate.push(i);
        l = i;
    }

    const nextPage = () => {
        let pageTo = currentPage + 1;
        setSearch(true)
        setCurrentPage(pageTo)
    }
    
    const previousPage = () => {
        let pageTo = currentPage - 1;
        setSearch(true)
        setCurrentPage(pageTo)
    }
    
    const skipPage = (pageNumber) => {
        setSearch(true)
        setCurrentPage(pageNumber)
    }
    
    return (
        <div className="pagination">
            <div onClick={() => { if (currentPage === 1) { return null } else { return previousPage() } }} className={hasPreviousPage ? 'nav prev' : 'nav prev disabled'}>Prev</div>
            {paginate.map((pag, index) => (
                (pag !== '...') ? <div className={`${pag === currentPage ? 'page current' : 'page'}`}
                    key={pag} id={pag} value={pag} onClick={() => skipPage(pag)}>{pag}</div> : <div key={`paginabc-${index}`}>{pag}</div>
            ))}
            <div onClick={() => nextPage()} className={hasNextPage ? 'nav next' : 'nav next disabled'}>Next</div>
        </div>
    )
}

export default Pagination